import React from 'react';
import * as styles from './styles.module.css';

function AlertBar({ children }) {
  return (
    <div className={styles['alert-bar']} role="alert">
      {children}
    </div>
  );
}

export default AlertBar;


